// FilterOptions.js

export const FILTER_GROUPS = [
  {
    groupKey: "pc",
    groupLabel: "PC",
    icon: "fa-gem",
    options: [
      { key: "pc", label: "Has PC" },
      { key: "pc_paid", label: "Paid", chargeType: "paid" },
      { key: "pc_due", label: "Not Paid (Due)", chargeType: "due" },
      { key: "pc_payback", label: "Payable Back", chargeType: "payback" },
    ],
  },
  {
    groupKey: "lab",
    groupLabel: "Lab",
    icon: "fa-flask",
    options: [
      { key: "lab", label: "Has Lab" },
      // ── With report ──
      { key: "lab_with_report", label: "With Report", subGroup: "with_report" },
      {
        key: "lab_with_report_paid",
        label: "With Report — Paid",
        subGroup: "with_report",
        chargeType: "paid",
      },
      {
        key: "lab_with_report_due",
        label: "With Report — Due",
        subGroup: "with_report",
        chargeType: "due",
      },
      {
        key: "lab_with_report_payback",
        label: "With Report — Payable Back",
        subGroup: "with_report",
        chargeType: "payback",
      },
      // ── Without report ──
      { key: "lab_no_report", label: "Without Report", subGroup: "no_report" },
      {
        key: "lab_no_report_paid",
        label: "Without Report — Paid",
        subGroup: "no_report",
        chargeType: "paid",
      },
      {
        key: "lab_no_report_due",
        label: "Without Report — Due",
        subGroup: "no_report",
        chargeType: "due",
      },
      {
        key: "lab_no_report_payback",
        label: "Without Report — Payable Back",
        subGroup: "no_report",
        chargeType: "payback",
      },
    ],
  },
  {
    groupKey: "bar",
    groupLabel: "Bar",
    icon: "fa-bars-staggered",
    options: [
      { key: "bar", label: "Has Bar" },
      { key: "bar_paid", label: "Paid", chargeType: "paid" },
      { key: "bar_due", label: "Not Paid (Due)", chargeType: "due" },
      { key: "bar_payback", label: "Payable Back", chargeType: "payback" },
    ],
  },
  {
    groupKey: "coin",
    groupLabel: "Coin",
    icon: "fa-coins",
    options: [
      { key: "coin", label: "Has Coin" },
      { key: "coin_paid", label: "Paid", chargeType: "paid" },
      { key: "coin_due", label: "Not Paid (Due)", chargeType: "due" },
      { key: "coin_payback", label: "Payable Back", chargeType: "payback" },
    ],
  },
  {
    groupKey: "ginni",
    groupLabel: "Ginni",
    icon: "fa-circle-dot",
    options: [
      { key: "ginni", label: "Has Ginni" },
      // ── With report ──
      {
        key: "ginni_with_report",
        label: "With Report",
        subGroup: "with_report",
      },
      {
        key: "ginni_with_report_paid",
        label: "With Report — Paid",
        subGroup: "with_report",
        chargeType: "paid",
      },
      {
        key: "ginni_with_report_due",
        label: "With Report — Due",
        subGroup: "with_report",
        chargeType: "due",
      },
      {
        key: "ginni_with_report_payback",
        label: "With Report — Payable Back",
        subGroup: "with_report",
        chargeType: "payback",
      },
      // ── Without report ──
      {
        key: "ginni_no_report",
        label: "Without Report",
        subGroup: "no_report",
      },
      {
        key: "ginni_no_report_paid",
        label: "Without Report — Paid",
        subGroup: "no_report",
        chargeType: "paid",
      },
      {
        key: "ginni_no_report_due",
        label: "Without Report — Due",
        subGroup: "no_report",
        chargeType: "due",
      },
      {
        key: "ginni_no_report_payback",
        label: "Without Report — Payable Back",
        subGroup: "no_report",
        chargeType: "payback",
      },
    ],
  },
  {
    groupKey: "silver",
    groupLabel: "Silver",
    icon: "fa-circle-half-stroke",
    options: [
      { key: "silver", label: "Has Silver" },
      { key: "silver_bar", label: "Silver Bar" },
      { key: "silver_paid", label: "Paid", chargeType: "paid" },
      { key: "silver_due", label: "Not Paid (Due)", chargeType: "due" },
      { key: "silver_payback", label: "Payable Back", chargeType: "payback" },
    ],
  },
  {
    groupKey: "cash",
    groupLabel: "Cash",
    icon: "fa-money-bill-wave",
    options: [{ key: "cash", label: "Has Cash" }],
  },
];

export const FILTER_OPTIONS = FILTER_GROUPS.flatMap((g) => g.options);

/* ─── chargeStatus helper ─── */
export const chargeStatus = (amount, paidAmount) => {
  if (!amount || amount === 0) return null;
  const paid = paidAmount || 0;
  if (paid > amount) return "payback";
  if (paid === amount) return "paid";
  return "due";
};

/* ─── rowPassesFilter ─── */
export const rowPassesFilter = (row, activeFilters) => {
  if (!activeFilters || activeFilters.size === 0) return true;
  const cs = (amount, paid) => chargeStatus(amount, paid);

  // PC
  if (activeFilters.has("pc") && row.pc?.weight > 0) return true;
  if (
    activeFilters.has("pc_paid") &&
    row.pc?.weight > 0 &&
    cs(row.pc?.charges, row.pc?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("pc_due") &&
    row.pc?.weight > 0 &&
    cs(row.pc?.charges, row.pc?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("pc_payback") &&
    row.pc?.weight > 0 &&
    cs(row.pc?.charges, row.pc?.paidAmount) === "payback"
  )
    return true;

  // Lab
  if (activeFilters.has("lab") && row.lab?.weight > 0) return true;
  if (
    activeFilters.has("lab_with_report") &&
    row.lab?.weight > 0 &&
    row.lab?.report
  )
    return true;
  if (
    activeFilters.has("lab_with_report_paid") &&
    row.lab?.weight > 0 &&
    row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("lab_with_report_due") &&
    row.lab?.weight > 0 &&
    row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("lab_with_report_payback") &&
    row.lab?.weight > 0 &&
    row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "payback"
  )
    return true;
  if (
    activeFilters.has("lab_no_report") &&
    row.lab?.weight > 0 &&
    !row.lab?.report
  )
    return true;
  if (
    activeFilters.has("lab_no_report_paid") &&
    row.lab?.weight > 0 &&
    !row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("lab_no_report_due") &&
    row.lab?.weight > 0 &&
    !row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("lab_no_report_payback") &&
    row.lab?.weight > 0 &&
    !row.lab?.report &&
    cs(row.lab?.charges, row.lab?.paidAmount) === "payback"
  )
    return true;

  // Bar
  if (activeFilters.has("bar") && row.bar?.weight > 0) return true;
  if (
    activeFilters.has("bar_paid") &&
    row.bar?.weight > 0 &&
    cs(row.bar?.charges, row.bar?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("bar_due") &&
    row.bar?.weight > 0 &&
    cs(row.bar?.charges, row.bar?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("bar_payback") &&
    row.bar?.weight > 0 &&
    cs(row.bar?.charges, row.bar?.paidAmount) === "payback"
  )
    return true;

  // Coin
  if (activeFilters.has("coin") && row.coin?.weight > 0) return true;
  if (
    activeFilters.has("coin_paid") &&
    row.coin?.weight > 0 &&
    cs(row.coin?.charges, row.coin?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("coin_due") &&
    row.coin?.weight > 0 &&
    cs(row.coin?.charges, row.coin?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("coin_payback") &&
    row.coin?.weight > 0 &&
    cs(row.coin?.charges, row.coin?.paidAmount) === "payback"
  )
    return true;

  // Ginni
  if (activeFilters.has("ginni") && row.ginni?.weight > 0) return true;
  if (
    activeFilters.has("ginni_with_report") &&
    row.ginni?.weight > 0 &&
    row.ginni?.report
  )
    return true;
  if (
    activeFilters.has("ginni_with_report_paid") &&
    row.ginni?.weight > 0 &&
    row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("ginni_with_report_due") &&
    row.ginni?.weight > 0 &&
    row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("ginni_with_report_payback") &&
    row.ginni?.weight > 0 &&
    row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "payback"
  )
    return true;
  if (
    activeFilters.has("ginni_no_report") &&
    row.ginni?.weight > 0 &&
    !row.ginni?.report
  )
    return true;
  if (
    activeFilters.has("ginni_no_report_paid") &&
    row.ginni?.weight > 0 &&
    !row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("ginni_no_report_due") &&
    row.ginni?.weight > 0 &&
    !row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("ginni_no_report_payback") &&
    row.ginni?.weight > 0 &&
    !row.ginni?.report &&
    cs(row.ginni?.charges, row.ginni?.paidAmount) === "payback"
  )
    return true;

  // Silver
  if (
    activeFilters.has("silver") &&
    (row.silver?.weight > 0 || row.silver?.silverBar > 0)
  )
    return true;
  if (activeFilters.has("silver_bar") && row.silver?.silverBar > 0) return true;
  if (
    activeFilters.has("silver_paid") &&
    row.silver?.weight > 0 &&
    cs(row.silver?.charges, row.silver?.paidAmount) === "paid"
  )
    return true;
  if (
    activeFilters.has("silver_due") &&
    row.silver?.weight > 0 &&
    cs(row.silver?.charges, row.silver?.paidAmount) === "due"
  )
    return true;
  if (
    activeFilters.has("silver_payback") &&
    row.silver?.weight > 0 &&
    cs(row.silver?.charges, row.silver?.paidAmount) === "payback"
  )
    return true;

  // Cash
  if (activeFilters.has("cash") && row.cash > 0) return true;

  return false;
};
